export default "__VITE_ASSET__72336293__"